import {Pipe, PipeTransform} from '@angular/core';
import {raceLengthFormat} from "@utility";
import {TranslocoService} from "@ngneat/transloco";

@Pipe({
    name: 'raceLengthFormat',
    standalone: false
})
export class RaceLengthFormatPipe implements PipeTransform {
    constructor(private transloco: TranslocoService) {
    }

  transform(length: number | string | undefined, activeLang?: string, unit?: "km" | "m" | undefined, withUnit: boolean = true): string | undefined {
    return raceLengthFormat(length, activeLang ?? this.transloco.getActiveLang(), unit, withUnit);
  }


}
